<template>
  <div class='custom-select' v-click-outside='close'>
    <input type='hidden' v-if='name' v-for='selection in Object.values(selections)' :name='name' :key='selection.id' :value='selection.id' />

    <div @click.prevent='open'>
      <input type='text' v-model='q' :disabled='disabled'>

      <div v-if='Object.keys(selections).length > 0' class='selected-option'>
        <ul>
          <li v-for='selection in Object.values(selections)' :key='selection.id'>
            <span @click='deselect(selection)'>x</span>
            {{ template(selection) }}
          </li>
        </ul>

        <a href="#" @click.prevent="clear" class="remove-all">
          {{ $t('relatico_multiselect.clear') }}
        </a>
      </div>
    </div>

    <ul v-show='opened' class='options-list' v-scroll='scroll'>
      <li v-if='!loading && creator && !isQueryInOptions' @click.prevent='create'>
        {{ $t('relatico_multiselect.create_new') + ' ' + q }}
      </li>

      <li @click.prevent='select(o)' v-for='o in options' :key='o.id'>
        {{ template(o) }}
      </li>

      <li v-show='loading'>
        {{ $t('shared.loading') }}
      </li>

      <li v-show='!loading && options.length == 0'>
        {{ $t('shared.no_results') }}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      getter: {
        type: Function,
        required: true
      },
      creator: {
        type: Function
      },
      name: {
        type: String
      },
      value: {
        type: Array,
        default: () => ([])
      },
      template: {
        type: Function,
        default: (x) => x.name
      },
      disabled: {
        type: Boolean,
        default: () => (false)
      }
    },
    created() {
      this.debouncedLoadMoreOptions = this._debounce(() => { this.loadMoreOptions() }, 500)
    },
    data() {
      return {
        q: '',
        opened: false,
        loading: false,
        noMoreResults: false,
        options: [],
        page: 0,
      }
    },
    watch: {
      q() {
        this.loading = true
        this.noMoreResults = false
        this.page = 0
        this.options = []

        this.debouncedLoadMoreOptions()
      }
    },
    computed: {
      isQueryInOptions() {
        if (this.q.length == 0)
          return true

        return this.options.some(o => this.$props.template(o) == this.q)
      },
      selections() {
        const res = {}

        this.value.forEach(v => res[v.id] = v)

        return res
      },
    },
    methods: {
      open() {
        if (this.disabled)
          return

        this.opened = true

        if (this.options.length == 0)
          this.loadMoreOptions()
      },
      close() {
        if (!this.opened || this.loading)
          return

        this.page = 0
        this.options = []
        this.opened = false
        this.noMoreResults = false
      },
      select(option) {
        const newSelection = Object.assign({}, this.selections, { [option.id]: option })
        this.$emit('input', Object.values(newSelection))
      },
      deselect(option) {
        const newSelection = Object.assign({}, this.selections)
        this.$delete(newSelection, option.id)
        this.$emit('input', Object.values(newSelection))
      },
      clear() {
        this.$emit('input', [])
      },
      loadMoreOptions() {
        this.loading = true

        this.$props.getter({ q: this.q.toLowerCase(), page: this.page + 1 }).then((data) => {
          this.loading = false
          this.page = data.meta.page

          if (data.data.length > 0)
            this.options = this.options.concat(data.data)
          else
            this.noMoreResults = true
        })
      },
      scroll(e) {
        if (this.loading || this.noMoreResults)
          return

        if (e.target.scrollTop / (e.target.scrollHeight - e.target.clientHeight) > 0.8) {
          this.loadMoreOptions()
        }
      },
      create() {
        this.loading = true

        this.$props.creator({ q: this.q }).then(({data}) => {
          this.q = ''
          this.select(data)
        })
      },
    }
  }
</script>

<style lang='sass' scoped>
  @import "../../styles/select"
</style>
